export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/craft_lessons.c670511.svg";